import React from 'react';
import { StoryObject } from '@benzinga/advanced-news-manager';
import { News } from '@benzinga/basic-news-manager';
import { getSponsoredContentLabel, isProOnlyPost, isPaywallArticle } from '@benzinga/article-manager';
import { PostCard, PostCardLayout, PostCardSize, PostCardProps } from './PostCard';
import styled from '@benzinga/themetron';

interface FeaturedCardProps extends Partial<PostCardProps> {
  layout?: PostCardLayout;
  loading?: 'lazy' | 'eager';
  node: StoryObject | News;
  size?: PostCardSize;
  sizes?: string;
  relativePath?: boolean;
  imageWidth?: number;
  fetchPriority?: 'auto' | 'low' | 'high';
  dataAction?: string;
}

export const FeaturedCard = ({
  dataAction,
  fetchPriority,
  hideEmptyThumb,
  hidePublishDate = false,
  imagePreload = false,
  imageWidth,
  layout = 'default',
  loading,
  node,
  relativePath,
  showCommentsIcon,
  size = 'default',
  sizes,
  summarySlot,
  tickerSlot,
}: FeaturedCardProps) => {
  if (!node) return <div />;

  const sponsoredData = getSponsoredContentLabel(node);
  const hasEdgeBadge = node ? isPaywallArticle(node) : false;

  const nodeUrl = relativePath ? node.url?.replace('https://www.benzinga.com/', '/') : node.url;

  const created = 'createdAt' in node ? node.createdAt.toString() : node.created;
  const description = 'teaserText' in node ? node.teaserText : node.teaser;
  const finalDataAction = dataAction || 'Featured Card Click';

  return (
    <Container data-action={finalDataAction}>
      <PostCard
        created={created}
        description={description ?? ''}
        fetchPriority={fetchPriority}
        hasEdgeBadge={hasEdgeBadge}
        hideEmptyThumb={hideEmptyThumb}
        hidePublishDate={hidePublishDate}
        id={node.id}
        image={node.image as string}
        imagePreload={imagePreload}
        imageWidth={imageWidth}
        isOnlyProPost={isProOnlyPost(node as StoryObject)}
        layout={layout}
        loading={loading}
        showCommentsIcon={showCommentsIcon && !sponsoredData.isSponsored}
        showProBadge={isProOnlyPost(node as StoryObject)}
        size={size}
        sizes={sizes}
        sponsored={sponsoredData.isSponsored}
        sponsoredLabel={sponsoredData.label}
        stocks={node.stocks}
        styles={{ titleLineHeight: 'snug' }}
        summarySlot={summarySlot}
        tickerSlot={tickerSlot}
        title={node.title}
        url={nodeUrl}
      />
    </Container>
  );
};

const Container = styled.div`
  @media screen and (max-width: 800px) {
    .post-title {
      margin-top: -4px;
    }
  }
`;
